import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

let camera, scene, renderer;
const loader = new GLTFLoader();
gsap.registerPlugin(ScrollTrigger);

export function startAnimation() {

	camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.01, 10);
	camera.position.z = 5;
	camera.rotation.z = 1;

	scene = new THREE.Scene();

	const lightForDrone = new THREE.AmbientLight(0xFF0000, 2);
	scene.add(lightForDrone);


	loader.load("./models/drone/scene.gltf", (gltf) => {
		let modelPos = gltf.scene
		modelPos.scale.set(.45, .45, .45)

		gsap.to(camera.position, {
			z: 1,
			duration: 1,
			ease: "back.out(1.7)"
		})
		gsap.to(camera.rotation, {
			z: 0,
			duration: 1
		})

		gsap.to(modelPos.rotation, {
			x: 0.7,
			duration: 1,
			delay: 0.5
		})
		gsap.to(modelPos.rotation, {
			y: Math.PI * 1.75,
			duration: 2,
			delay: 1
		})
		gsap.to(modelPos.scale, {

			duration: 1,
			x: .55,
			y: .55,
			z: .55
		})
		gsap.to(modelPos.position, {
			delay: 1,
			duration: 1,
			x: 0.6,
			y: 0.1,
		})

		// product ddrone

		// gsap.to(modelPos.rotation, {
		// 	x: 1.5,
		// 	y: -0.9,
		// 	z: -0.1,
		// 	scrollTrigger: {
		// 		trigger: ".div2",
		// 		start: "top bottom",
		// 		end: "top top",
		// 		scrub: 0.2,
		// 		immediateRender: false,
		// 	},
		// })
		gsap.to(modelPos.scale, {
			delay: 1,
			duration: 1,
			x: .20,
			y: .20,
			z: .20,
			scrollTrigger: {
				trigger: ".droneProduct",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.position, {
			delay: 1,
			duration: 1,
			x: -0.45,
			y: 0,
			scrollTrigger: {
				trigger: ".droneProduct",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})

		// div 2
		gsap.to(modelPos.rotation, {
			x: 1.5,
			y: -0.9,
			z: -0.1,
			scrollTrigger: {
				trigger: ".div2",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.scale, {
			delay: 1,
			duration: 1,
			x: .35,
			y: .35,
			z: .35,
			scrollTrigger: {
				trigger: ".div2",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.position, {
			delay: 1,
			duration: 1,
			x: 0,
			y: 0,
			scrollTrigger: {
				trigger: ".div2",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.scale, {
			delay: 1,
			duration: 1,
			x: .55,
			y: .55,
			z: .55,
			scrollTrigger: {
				trigger: ".div3",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.rotation, {
			x: 0.403,
			y: 0.957,
			z: -0.421,
			scrollTrigger: {
				trigger: ".div3",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.position, {
			delay: 1,
			duration: 1,
			x: -0.8,
			y: 0,
			scrollTrigger: {
				trigger: ".div3",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.position, {
			delay: 1,
			duration: 1,
			x: 0,
			y: 0,
			scrollTrigger: {
				trigger: ".div4",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		gsap.to(modelPos.scale, {

			x: 0.85,
			y: 0.85,
			z: 0.85,
			scrollTrigger: {
				trigger: ".div4",
				start: "top bottom",
				end: "top top",
				scrub: 0.2,
				immediateRender: false,
			},
		})
		scene.add(modelPos);
	})

	renderer = new THREE.WebGLRenderer({ antialias: true });
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.setAnimationLoop(animationRender);
	renderer.setClearColor(0x272727, 1);
	document.body.appendChild(renderer.domElement);

	window.addEventListener('resize', () => {
		camera.aspect = window.innerWidth / window.innerHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(window.innerWidth, window.innerHeight);
	});
}

function animationRender() {
	renderer.render(scene, camera);
}
